import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, IHomeState } from './state';

export const NAME = 'home';
export const store: Module<IHomeState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
